import {request} from '../jslib/request'
const BASE_REQUEST = '/tms/paymentBillSettleApply'
const BASE_REQUEST2 = '/tms/receiveBillOutApply'


export function savePayment(querydata) {
  return request({
    url:`${BASE_REQUEST}/savePayment`,
    method: 'post',
    json: true,
    data:querydata
  })
}

export function getPayment(querydata) {
  return request({
    url:`${BASE_REQUEST}/getPayment`,
    data:querydata
  })
}
export function fanDianCustomerInfo(querydata) {
  return request({
    url:`${BASE_REQUEST}/fanDianCustomerInfo`,
    data:querydata
  })
}
export function heTongInfo(querydata) {
  return request({
    url:`${BASE_REQUEST}/heTongInfo`,
    data:querydata
  })
}
export function saveTicket(querydata) {
  return request({
    url:`${BASE_REQUEST}/saveTicket`,
    data:querydata
  })
}

export function getBatchTicketApprove(querydata) {
  return request({
    url:`${BASE_REQUEST}/getBatchTicketApprove`,
    data:querydata
  })
}

export function saveTicketBatch(querydata) {
  return request({
    url:`${BASE_REQUEST}/saveTicketBatch`,
    data:querydata
  })
}

export function getTemporaryTicket(querydata) {
  return request({
    url:`${BASE_REQUEST}/getTemporaryTicket`,
    data:querydata
  })
}

export function temporarySaveTicket(querydata) {
  return request({
    url:`${BASE_REQUEST}/temporarySaveTicket`,
    data:querydata
  })
}

export function temporarySaveTicketNoCost(querydata) {
  return request({
    url:`${BASE_REQUEST}/temporarySaveTicketNoCost`,
    data:querydata
  })
}

export function deleteTemporaryTicket(querydata) {
  return request({
    url:`${BASE_REQUEST}/deleteTemporaryTicket`,
    data:querydata
  })
}
export function listAndFinish({pageNo,pageSize,comKeyword,shipName,billTotal,billNo}) {
  return request({
    url:`${BASE_REQUEST2}/listAndFinish`,
    data: {
      pageNo,pageSize,comKeyword,shipName,billTotal,billNo
    }
  })
}
export function getProcessInstanceIdByBillOutApplyId(billOutApplyId) {
  return request({
    url:`${BASE_REQUEST2}/getProcessInstanceIdByBillOutApplyId`,
    data: {
      billOutApplyId
    }
  })
}
export function saveReceiveBillOutApplyTrackingNumber({id,trackingNumber}) {
  return request({
    url:`${BASE_REQUEST2}/saveReceiveBillOutApplyTrackingNumber`,
    data: {
      id: id,
      trackingNumber: trackingNumber
    }
  })
}
export function saveInvoiceAttachStatusByProcessId({processId,invoiceAttachStatus,errmsg}) {
  return request({
    url:`${BASE_REQUEST2}/saveInvoiceAttachStatusByProcessId`,
    data: {
      processId: processId,
      invoiceAttachStatus: invoiceAttachStatus,
      errmsg: errmsg
    }
  })
}
export function saveInvoiceAttachSendStatusByProcessId({processId,invoiceSendAttachStatus}) {
  return request({
    url:`${BASE_REQUEST2}/saveInvoiceAttachSendStatusByProcessId`,
    data: {
      processId: processId,
      invoiceSendAttachStatus: invoiceSendAttachStatus
    }
  })
}
export function sendApplicantMsg(processId) {
  return request({
    url:`${BASE_REQUEST2}/sendApplicantMsg`,
    data: {
      processId: processId
    }
  })
}
export function saveReceiveBillOutApplyInvoicePictures({id,invoicePictures}) {
  return request({
    url:`${BASE_REQUEST2}/saveReceiveBillOutApplyInvoicePictures`,
    data: {
      id: id,
      invoicePictures: invoicePictures
    }
  })
}
export function saveReceiveBillOutApplyMassInvoicePictures({id,invoicePictures}) {
  return request({
    url: `${BASE_REQUEST2}/saveReceiveBillOutApplyMassInvoicePictures`,
    json:true,
    data: {
      id: id,
      invoicePictures: invoicePictures
    }
  })
}
export function saveReceiveBillOutApplyInvoiceNos({id,invoiceNos}) {
  return request({
    url:`${BASE_REQUEST2}/saveReceiveBillOutApplyInvoiceNos`,
    data: {
      id: id,
      invoiceNos: invoiceNos
    }
  })
}

export function saveReceive(querydata) {
  return request({
    url:`${BASE_REQUEST2}/saveReceive`,
    data:querydata
  })
}

export function getReceive(querydata) {
  return request({
    url:`${BASE_REQUEST2}/getReceive`,
    data:querydata
  })
}

export function saveBillOut(querydata) {
  return request({
    url:`${BASE_REQUEST2}/saveBillOut`,
    data:querydata
  })
}

export function updateReceiptPicUrl(querydata) {
  return request({
    url:`${BASE_REQUEST}/updateReceiptPicUrl`,
    data:querydata
  })
}

export function getReceiptPicUrl(querydata) {
  return request({
    url:`${BASE_REQUEST}/getReceiptPicUrl`,
    data:querydata
  })
}

export function saveNoCostBill(obj) {
  return request({
    url:`${BASE_REQUEST}/saveNoCostBill`,
    data:obj
  })
}

export function getNoCostBillList(querydata) {
  return request({
    url:`${BASE_REQUEST}/getNoCostBillList`,
    data:querydata
  })
}

export function delNoCostBillList(querydata) {
  return request({
    url:`${BASE_REQUEST}/delNoCostBillList`,
    data:querydata
  })
}

export function checkApplyCost(querydata) {
  return request({
    url:`${BASE_REQUEST}/checkApplyCost`,
    data:querydata
  })
}

export function getPriceSumBySysSupplierIdAndGoing(querydata) {
  return request({
    url:`${BASE_REQUEST}/getPriceSumBySysSupplierIdAndGoing`,
    data:querydata
  })
}
export function getCustomerInfoByGoodsCostId(goodsCostId,contractId,processId) {
  return request({
    url:`${BASE_REQUEST}/getCustomerInfoByGoodsCostId`,
    data:{goodsCostId,contractId,processId}
  })
}
export function removeCustomizeInfoByGoodsCostId(goodsCostId) {
  return request({
    url: `${BASE_REQUEST}/removeCustomizeInfoByGoodsCostId`,
    method:'get',
    data:{goodsCostId}
  })
}

export function saveCustomizeListByContractId(list,contractId,processId) {
  return request({
    url: `${BASE_REQUEST}/saveCustomizeListByContractId?contractId=${contractId}&processId=${processId}`,
    method: 'post',
    json: true,
    data:list
  })
}

export function addCustomInformation({type,price,inAndOut,goodsCostId,mainGoodsCostId}) {
  return request({
    url:`${BASE_REQUEST}/addCustomInformation`,
    data:{type,price,inAndOut,goodsCostId,mainGoodsCostId}
  })
}
export function deleteCustomInformation({ customId, inAndOut, goodsCostId, mainGoodsCostId }) {
  return request({
    url:`${BASE_REQUEST}/deleteCustomInformation`,
    data:{customId,inAndOut,goodsCostId,mainGoodsCostId}
  })
}
export function updateCustomInformation({ customId, type, price, inAndOut, goodsCostId, mainGoodsCostId }) {
  return request({
    url:`${BASE_REQUEST}/updateCustomInformation`,
    data:{customId,type,price,inAndOut,goodsCostId,mainGoodsCostId}
  })
}
